import React from "react";

import { faAdd, faBracketsCurly } from "@fortawesome/pro-regular-svg-icons";

import { EmptyState } from "src/design-system/EmptyState";

export type JsonSchemaEmptyStateProps = {
  immutable: boolean;
  onAddField: () => void;
  onOpenRawJsonView?: () => void;
};

export const JsonSchemaEmptyState: React.FC<JsonSchemaEmptyStateProps> = ({
  immutable,
  onAddField,
  onOpenRawJsonView,
}) => {
  return (
    <EmptyState
      dataLoc="json-schema-empty-state"
      icon={faBracketsCurly}
      headline="Create structured output"
      description="Click below to start creating your structured output by adding a field
        or creating from JSON schema."
      actionButton={
        onOpenRawJsonView
          ? [
              {
                label: "Add field",
                icon: faAdd,
                isDisabled: immutable,
                dataLoc: "add-jsonschema-field",
                onClick: onAddField,
              },
              {
                label: "JSON schema",
                icon: faBracketsCurly,
                isDisabled: immutable,
                dataLoc: "open-json-schema-editor",
                onClick: onOpenRawJsonView,
              },
            ]
          : {
              label: "Add field",
              icon: faAdd,
              isDisabled: immutable,
              dataLoc: "add-jsonschema-field",
              onClick: onAddField,
            }
      }
    />
  );
};
